import { isNil, negate } from 'lodash-es'

export const isNotNil = <T>(value: T | null | undefined): value is T =>
  negate(isNil)(value)
